import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import modal from 'Demora/modals/modal';

import GroupSettingsModal from './GroupSettingsModal';

class GroupSettings extends Component {
	showSettings = () => {
		let m = {
			id: 'edit_group',
			header: 'Edit Group',
			noFooter: true,
		};

		m.body = <GroupSettingsModal obj={this.props.obj} />;

		modal(m);
	};

	render() {
		let obj = this.props.obj;

		let feed = this.props.feed[obj];

		let admin = parseFloat(feed.role) == 255;

		if (!admin) {
			return null;
		}

		return (
			<div onClick={this.showSettings}>
				<i className='fas fa-cog'></i>&nbsp;Group Admin Settings
			</div>
		);
	}
}

export default ReduxConnect(GroupSettings, {
	feed: 'feed',
});
